import Vue from 'vue'

const ToastInstance = Vue.extend(require('./toast.vue').default);
let instance = null
let count = null

let getInstance = () => {
  return new ToastInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  clearTimeout(count)
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
}

let Toast = (msg, time) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  instance.open(msg)
  count = setTimeout(() => {
    close()
  }, time || 5000)
}

export default Toast
